/* istanbul ignore file */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpBaseService } from '../../../core';
import { environment } from '../../../environments/environment';
import { AppCategories } from '../../models';

@Injectable({
    providedIn: 'root'
})

export class AppCategoriesDataService extends HttpBaseService {

    private route = environment.api + 'app-categories/';

    constructor(
        private _httpClient: HttpClient,
    ) {
        super(_httpClient);
    }

    getAppCategories(): Observable<AppCategories | null> {
        return this.httpGet(this.route);
    }
}
